import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { Link } from 'gatsby';
import { PropTableValues } from '../../src/components';
import { Label } from '@primer/react';
import { HeadingTags, HeadingSizes } from '@primer/react-brand';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {BreakoutBanner} from '@primer/react-brand'
`}</code></pre>
    <h2>{`Examples`}</h2>
    <h3>{`Default`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<BreakoutBanner>
  <BreakoutBanner.Heading>
    Where the most ambitious teams build great things
  </BreakoutBanner.Heading>
  <BreakoutBanner.LinkGroup>
    <Link href="#">Primary action</Link>
  </BreakoutBanner.LinkGroup>
</BreakoutBanner>
`}</code></pre>
    <h3>{`Optional description`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<BreakoutBanner>
  <BreakoutBanner.Heading>
    Where the most ambitious teams build great things
  </BreakoutBanner.Heading>
  <BreakoutBanner.Description>
    Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sapien sit
    ullamcorper id. Aliquam luctus sed turpis felis nam pulvinar risus
    elementum.
  </BreakoutBanner.Description>
  <BreakoutBanner.LinkGroup>
    <Link href="#">Primary action</Link>
  </BreakoutBanner.LinkGroup>
</BreakoutBanner>
`}</code></pre>
    <h3>{`Additional action`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<BreakoutBanner>
  <BreakoutBanner.Heading>
    Where the most ambitious teams build great things
  </BreakoutBanner.Heading>
  <BreakoutBanner.LinkGroup>
    <Link href="#">Primary action</Link>
    <Link href="#">Secondary action</Link>
  </BreakoutBanner.LinkGroup>
</BreakoutBanner>
`}</code></pre>
    <h3>{`Vertically stacked actions`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<BreakoutBanner>
  <BreakoutBanner.Heading>
    Where the most ambitious teams build great things
  </BreakoutBanner.Heading>
  <BreakoutBanner.LinkGroup direction="vertical">
    <Link href="#">Primary action</Link>
    <Link href="#">Secondary action</Link>
  </BreakoutBanner.LinkGroup>
</BreakoutBanner>
`}</code></pre>
    <h3>{`Alignment`}</h3>
    <p>{`The content alignment can be changed using the `}<inlineCode parentName="p">{`align`}</inlineCode>{` prop on the root `}<inlineCode parentName="p">{`BreakoutBanner`}</inlineCode>{`. This can be configured to either `}<inlineCode parentName="p">{`start`}</inlineCode>{` or `}<inlineCode parentName="p">{`center`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<BreakoutBanner align="center">
  <BreakoutBanner.Heading>
    Where the most ambitious teams build great things
  </BreakoutBanner.Heading>
  <BreakoutBanner.Description>
    Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sapien sit
    ullamcorper id. Aliquam luctus sed turpis felis nam pulvinar risus
    elementum.
  </BreakoutBanner.Description>
  <BreakoutBanner.LinkGroup>
    <Link href="#">Primary action</Link>
    <Link href="#">Secondary action</Link>
  </BreakoutBanner.LinkGroup>
</BreakoutBanner>
`}</code></pre>
    <h3>{`Leading visual`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<BreakoutBanner leadingVisual={<LogoGithubIcon size="medium" />}>
  <BreakoutBanner.Heading>
    Where the most ambitious teams build great things
  </BreakoutBanner.Heading>
  <BreakoutBanner.LinkGroup>
    <Link href="#">Primary action</Link>
  </BreakoutBanner.LinkGroup>
</BreakoutBanner>
`}</code></pre>
    <h3>{`Optional background image`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<ThemeProvider colorMode="dark">
  <BreakoutBanner
    backgroundImageSrc={{
      narrow:
        'https://github.com/user-attachments/assets/a28110fd-d019-41a4-8f80-b49ae8895708',
      regular:
        'https://github.com/user-attachments/assets/a28110fd-d019-41a4-8f80-b49ae8895708',
      wide: 'https://github.com/user-attachments/assets/a28110fd-d019-41a4-8f80-b49ae8895708',
    }}
  >
    <BreakoutBanner.Heading>
      Where the most ambitious teams build great things
    </BreakoutBanner.Heading>
    <BreakoutBanner.LinkGroup>
      <Link href="#">Primary action</Link>
    </BreakoutBanner.LinkGroup>
  </BreakoutBanner>
</ThemeProvider>
`}</code></pre>
    <h3>{`Optional background color`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<BreakoutBanner backgroundColor="var(--base-color-scale-blue-0)">
  <BreakoutBanner.Heading>
    Where the most ambitious teams build great things
  </BreakoutBanner.Heading>
  <BreakoutBanner.Description>
    Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sapien sit
    ullamcorper id. Aliquam luctus sed turpis felis nam pulvinar risus
    elementum.
  </BreakoutBanner.Description>
  <BreakoutBanner.LinkGroup>
    <Link href="#">Primary action</Link>
    <Link href="#">Secondary action</Link>
  </BreakoutBanner.LinkGroup>
</BreakoutBanner>
`}</code></pre>
    <h2>{`Component props`}</h2>
    <h3>{`BreakoutBanner `}<Label mdxType="Label">{`Required`}</Label></h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`ReactNode`}</inlineCode>{`, `}<inlineCode parentName="td">{`ReactNode[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Content to include within the banner component`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`align`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><PropTableValues values={[`start`, `center`]} addLineBreaks commaSeparated mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`'start'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The horizontal positioning of content wihin the banner component`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`backgroundColor`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><PropTableValues values={['default', 'subtle', 'string', `ResponsiveMap`]} addLineBreaks commaSeparated mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`'subtle'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Optional, custom background color`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`backgroundImageSrc`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><PropTableValues values={['string', `ResponsiveMap`]} addLineBreaks commaSeparated mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Optional, custom background image`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`backgroundImagePosition`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><PropTableValues values={['string', `ResponsiveMap`]} addLineBreaks commaSeparated mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`'center'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Optional, custom background position`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`backgroundImageSize`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><PropTableValues values={['string', `ResponsiveMap`]} addLineBreaks commaSeparated mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`'cover'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Optional, custom background position size`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`leadingVisual`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`ReactElement`}</inlineCode>{`, `}<inlineCode parentName="td">{`Icon`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`An optional leading visual that appears before the heading`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`BreakoutBanner.Heading `}<Label mdxType="Label">{`Required`}</Label></h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`ReactNode`}</inlineCode>{`, `}<inlineCode parentName="td">{`ReactNode[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Content to be displayed inside the `}<inlineCode parentName="td">{`BreakoutBanner.Heading`}</inlineCode>{` component`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`as`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><PropTableValues values={HeadingTags} addLineBreaks mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`h3`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Heading level`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`size`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><PropTableValues values={HeadingSizes} addLineBreaks mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`4`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Visual heading size, irrespective of level`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`BreakoutBanner.Description`}</h3>
    <p>{`Optional child that can be used to provide additional information.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`ReactNode`}</inlineCode>{`, `}<inlineCode parentName="td">{`ReactNode[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Content to be displayed inside the banner component`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`BreakoutBanner.LinkGroup`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Link`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`undefined`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The links to be displayed within the group`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`direction`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><PropTableValues values={['horizontal', 'vertical', `ResponsiveMap`]} addLineBreaks commaSeparated mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`'horizontal'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Positioning of the links across x and y axis`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`All components forward `}<inlineCode parentName="p">{`id`}</inlineCode>{`, `}<inlineCode parentName="p">{`className`}</inlineCode>{` and `}<inlineCode parentName="p">{`ref`}</inlineCode>{` by default`}</p>
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul">
        <Link to="/components/CTABanner" mdxType="Link">CTABanner</Link>
      </li>
      <li parentName="ul">
        <Link to="/components/Bento" mdxType="Link">Bento</Link>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      